import './EventTimeSlots.scss';

const EventTimeSlots = ({ timeslots, showSelectedTime, setShowSelectedTime }) => {
    const groupTimeSlots = (slots) => {
        const morning = [];
        const afternoon = [];
        const evening = [];

        slots.forEach((slot) => {
            const [hour, minute] = slot.time_slot.split(':').map(Number);
            if (hour < 12) {
                morning.push(slot);
            } else if (hour >= 12 && hour < 16) {
                afternoon.push(slot);
            } else {
                evening.push(slot);
            }
        });

        return { morning, afternoon, evening };
    };

    const { morning, afternoon, evening } = groupTimeSlots(timeslots);

    const renderSlots = (slots) =>
        slots.map((slot, index) => (
            <div
                key={index}
                className={`time-slot ${slot.isBooked ? 'booked pe-none' : 'available'}`}
                style={{
                    backgroundColor:
                        showSelectedTime === slot.time_slot
                            ? '#000'
                            : slot.isBooked
                            ? '#EEF0F3'
                            : '#EEF0F3',
                    color:
                        showSelectedTime === slot.time_slot
                            ? '#FFF'
                            : slot.isBooked
                            ? '#878787'
                            : '#000',
                    cursor: slot.isBooked ? 'default' : 'pointer',
                    textDecoration:
                        slot.isBooked && showSelectedTime !== slot.time_slot
                            ? 'line-through'
                            : 'none',
                }}
                onClick={() => {
                    setShowSelectedTime(slot?.time_slot);
                }}
            >
                {slot.time_slot}
            </div>
        ));

    return (
        <div className="time-slot-wrapper">
            {/* <div className="event-wrapper">
                <p>Morning</p>
                <div className="events-slots">{renderSlots()}</div>
            </div> */}
            {morning.length > 0 && (
                <div className="event-wrapper">
                    <p>Morning</p>
                    <div className="events-slots">{renderSlots(morning)}</div>
                </div>
            )}
            {afternoon.length > 0 && (
                <div className="event-wrapper">
                    <p>Afternoon</p>
                    <div className="events-slots">{renderSlots(afternoon)}</div>
                </div>
            )}
            {evening.length > 0 && (
                <div className="event-wrapper">
                    <p>Evening</p>
                    <div className="events-slots">{renderSlots(evening)}</div>
                </div>
            )}
        </div>
    );
};

export default EventTimeSlots;
